/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Primary rate-monitoring state for a My Trips reservation.
 * @export
 */
export const MonitoringStatus = {
    Autosave: 'AUTOSAVE',
    Monitoring: 'MONITORING',
    NeedsInfo: 'NEEDS_INFO',
    Unsupported: 'UNSUPPORTED',
    NotRefundable: 'NOT_REFUNDABLE',
    Cancelled: 'CANCELLED'
} as const;
export type MonitoringStatus = typeof MonitoringStatus[keyof typeof MonitoringStatus];


export function instanceOfMonitoringStatus(value: any): boolean {
    for (const key in MonitoringStatus) {
        if (Object.prototype.hasOwnProperty.call(MonitoringStatus, key)) {
            if (MonitoringStatus[key as keyof typeof MonitoringStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MonitoringStatusFromJSON(json: any): MonitoringStatus {
    return MonitoringStatusFromJSONTyped(json, false);
}

export function MonitoringStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoringStatus {
    return json as MonitoringStatus;
}

export function MonitoringStatusToJSON(value?: MonitoringStatus | null): any {
    return value as any;
}

export function MonitoringStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): MonitoringStatus {
    return value as MonitoringStatus;
}

